import { render, staticRenderFns } from "./CardDoughnutChart.vue?vue&type=template&id=33119170&scoped=true"
import script from "./CardDoughnutChart.vue?vue&type=script&lang=js"
export * from "./CardDoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./CardDoughnutChart.vue?vue&type=style&index=0&id=33119170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33119170",
  null
  
)

export default component.exports